import { useId } from 'react'
import { useRouter } from 'next/router'

import Block from '@/layouts/block'
import { ButtonLinkPrimaryArrow, ButtonPrimaryArrow } from '@/components/button'
import { P1 } from '@/components/typography'
import { routes } from '@/lib/constants'

interface PaginationProps {
  currentPage: number
  totalPages: number
  handlePageChange: (page: number) => (e: React.MouseEvent) => void
}

const PagesNumbers = ({
  totalPages,
  currentPage,
  handlePageChange
}: PaginationProps) => {
  const pageNumberId = useId()

  return (
    <div className="lg:max-w-[444px] flex justify-start items-center gap-9  overflow-hidden">
      {Array.from({ length: totalPages }).map((_, index) => {
        const isActive = index + 1 === currentPage

        return (
          <button
            key={` ${pageNumberId}--${index}`}
            onClick={handlePageChange(index + 1)}
          >
            <P1
              className={`${isActive ? `pagination--active` : ''} pagination`}
            >
              {index + 1}
            </P1>
          </button>
        )
      })}
    </div>
  )
}

const Pagination = ({
  currentPage,
  totalPages,
  handlePageChange,
}: PaginationProps) => {
  return (
    <Block className="lg:max-w-[522px] mx-auto flex justify-center items-center gap-9 col-start-1 col-end-3 md:col-start-3 md:col-end-7 lg:col-start-5 lg:col-end-13 max-w-full">
      <ButtonPrimaryArrow
        isDisabled={currentPage === 1}
        className="rotate-180"
        onClick={handlePageChange(currentPage - 1)}
      />
      <PagesNumbers totalPages={totalPages} currentPage={currentPage} handlePageChange={handlePageChange} />
      <ButtonPrimaryArrow
        isDisabled={totalPages === currentPage}
        onClick={handlePageChange(currentPage + 1)}
      />
    </Block>
  )
}

export default Pagination
